import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMOURisk } from '../contracts/mou-risk.contract';
import { MOURiskService } from '../services';

interface IInitialState {
    List: {
        [key: string]:
            | {
                  IMONumber: string;
                  MOURisk: IMOURisk[] | undefined;
                  IsLoading: boolean;
                  ErrorMessage: string | undefined;
              }
            | undefined;
    };
    Selected: {
        [key: string]: IMOURisk | undefined;
    };
}

const initialState: IInitialState = {
    List: {},
    Selected: {}
};

const Fetch = {
    GetByIMONumber: createAsyncThunk('mourisk/GetByIMONumber', async (imoNumber: string, { rejectWithValue }) => {
        try {
            const res = await MOURiskService.getByIMONumber(imoNumber);
            return { IMONumber: imoNumber, res };
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const MOURiskSlice = createSlice({
    name: 'mouRisk',
    initialState: initialState,
    reducers: {
        SelectByVesselMOU: (state, action: PayloadAction<{ IMONumber: string; MOU: string }>) => {
            const { IMONumber, MOU } = action.payload;

            if (MOU != undefined && MOU != '') {
                const mou = state.List[IMONumber]?.MOURisk?.find((item) => item.MOU.toLowerCase() === MOU.toLowerCase());
                state.Selected[IMONumber] = mou;
            } else {
                state.Selected[IMONumber] = undefined;
            }
        }
    },
    extraReducers: (builder) => {
        // GetByIMONumber
        builder.addCase(Fetch.GetByIMONumber.pending, (state, action: any) => {
            state.List[action.meta.arg] = { IMONumber: action.meta.arg, MOURisk: undefined, IsLoading: true, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetByIMONumber.fulfilled, (state, action: PayloadAction<{ IMONumber: string; res: IMOURisk[] }>) => {
            const { IMONumber, res } = action.payload;
            state.List[IMONumber] = { IMONumber, MOURisk: res, IsLoading: false, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetByIMONumber.rejected, (state, action: PayloadAction<any>) => {
            const { IMONumber, res } = action.payload;
            state.List[IMONumber] = { IMONumber, MOURisk: undefined, IsLoading: false, ErrorMessage: res };
        });
    }
});

export const MOURiskFetch = Fetch;
export const MOURiskAction = MOURiskSlice.actions;
export const MOURIskReducer = MOURiskSlice.reducer;
